import styled from 'styled-components';

// Helper to compute half gutter with proper units
const halfGutter = (g?: number | string): string => {
  if (g === undefined) return '5px'; // default half-gutter
  if (g === 0) return '0'; // handle 0 explicitly
  if (typeof g === 'number') return `${String(g / 2)}px`;
  const s = typeof g === 'string' ? g.trim() : String(g).trim();
  const hasUnitsOrVar = /[a-z%)]|var\(/i.test(s); // units or CSS var()
  if (hasUnitsOrVar) return `calc(${s} / 2)`;
  const n = Number(s);
  return Number.isFinite(n) ? `${String(n / 2)}px` : '5px';
};

type Props = {
  gutter?: number | string;
  justify?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  align?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  alignContent?:
    | 'stretch'
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  fullWidth?: boolean;
  wrap?: boolean;
};

export const Stack = styled.div<Props>`
  display: flex;
  flex-wrap: ${(props) => (props.wrap ? 'wrap' : 'nowrap')};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'flex-start'};
  align-items: ${(props) => props.align || 'center'};
  align-content: ${(props) => props.alignContent || 'stretch'};
  ${(props) => props.fullWidth && 'flex: 1'};
  && > * {
    margin-right: ${(props) =>
      props.direction?.startsWith('column')
        ? '0'
        : props.gutter !== undefined
          ? halfGutter(props.gutter)
          : '5px'} !important;
    margin-left: ${(props) =>
      props.direction?.startsWith('column')
        ? '0'
        : props.gutter !== undefined
          ? halfGutter(props.gutter)
          : '5px'} !important;
    margin-top: ${(props) =>
      props.direction?.startsWith('column')
        ? props.gutter !== undefined
          ? halfGutter(props.gutter)
          : '5px'
        : '0'} !important;
    margin-bottom: ${(props) =>
      props.direction?.startsWith('column')
        ? props.gutter !== undefined
          ? halfGutter(props.gutter)
          : '5px'
        : '0'} !important;
  }
  && > *:last-child {
    margin-right: 0 !important;
  }
  && > *:first-child {
    margin-left: 0 !important;
  }
  ${(props) =>
    props.direction?.startsWith('column') &&
    `
    && > *:first-child {
      margin-top: 0 !important;
    }
    && > *:last-child {
      margin-bottom: 0 !important;
    }
  `}
`;
